import Util from '../utils/util';
import Symbol from './Symbol';

/**
 * 线符号基类,所有线符号均从此类派生.
 */

export default class LineSymbol extends Symbol {
    /**
     * 继承方法,继承自[Symbol]{@link Symbol}类.
     * @param {Object} options - 符号设置的属性
     * @returns {undefined}
     */
    constructor(options) {
        // 执行父类初始化
        super(options);

        /**
         * 线宽度，默认值1
         * @type {number}
         */
        this.width = 1;

        /**
         * 线颜色，默认值'black'
         * @type {string}
         */
        this.color = 'black';

        /**
         * 线条透明度,默认值1
         * @type {Number}
         * */
        this.opacity = 1;
    }

    /**
     * 重写父类方法,设置符号属性.
     * @param {Object} json - 符号设置的属性
     * @returns {undefined}
     */
    fromJson(json) {
        super.fromJson(json);

        this._setValue('width', json.width);
        this._setValue('color', json.color);
        this._setValue('opacity', json.opacity);
    }

    /**
     * 重写父类方法,导出符号属性.
     * @returns {Object} json - 符号的属性
     */
    toJson() {
        const json = super.toJson();

        return {
            ...json,
            width: this.width,
            color: this.color,
            opacity: this.opacity
        };
    }
}
